import React from 'react';
import { motion } from 'framer-motion';
import CallButton from '../components/CallButton';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { businessInfo } from '../data/businessData';
import { useLanguage } from '../context/LanguageContext';

const { FiMapPin, FiClock } = FiIcons;

export default function Contact() {
  const { t, lang } = useLanguage();

  return (
    <div className="container mx-auto px-4 py-16 max-w-6xl">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-16">
        <h1 className="text-5xl font-bold text-brand-navy mb-4">{t('contact.title')}</h1>
        <div className="h-1 w-24 bg-brand-gold mx-auto rounded mb-6"></div>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          {t('contact.subtitle')}
        </p>
      </motion.div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
        {/* Info Column */}
        <motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} className="bg-gray-50 p-8 md:p-12 rounded-3xl border border-gray-100 h-full flex flex-col justify-center">
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-brand-navy mb-6 flex items-center gap-3">
              <SafeIcon icon={FiMapPin} className="text-brand-red" /> {t('contact.location')}
            </h2>
            <p className="text-gray-700 text-lg leading-relaxed">
              {businessInfo.address.full}
            </p>
          </div>
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-brand-navy mb-6 flex items-center gap-3">
              <SafeIcon icon={FiClock} className="text-brand-red" /> {t('contact.hours')}
            </h2>
            <ul className="text-gray-700 text-lg space-y-2">
              {businessInfo.hours.map((item, idx) => (
                <li key={idx} className={`flex justify-between ${idx !== businessInfo.hours.length - 1 ? 'border-b border-gray-200 pb-2 pt-2' : 'pt-2'}`}>
                  <span>{item.days[lang]}</span>
                  <span>{item.time}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-auto text-center pt-8 border-t border-gray-200">
            <p className="text-gray-600 mb-6 font-medium">{t('contact.cta')}</p>
            <CallButton className="w-full md:w-auto" />
          </div>
        </motion.div>
        {/* Map Column */}
        <motion.div initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} className="h-[500px] lg:h-full min-h-[500px] rounded-3xl overflow-hidden shadow-lg border border-gray-200">
          <iframe src={businessInfo.googleMapsEmbedUrl} width="100%" height="100%" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Johnny's Bar Billard Location Map"></iframe>
        </motion.div>
      </div>
    </div>
  );
}